// Shared API client for the Pinlayr SaaS platform.
// Always talks to the backend via REACT_APP_BACKEND_URL and sends the
// session cookie (credentials: 'include'). Never hardcode the base URL.
const BASE = process.env.REACT_APP_BACKEND_URL;

async function request(path, { method = "GET", body, headers } = {}) {
  const res = await fetch(`${BASE}${path}`, {
    method,
    headers: { "Content-Type": "application/json", ...(headers || {}) },
    credentials: "include",
    body: body ? JSON.stringify(body) : undefined,
  });
  let data = {};
  try {
    data = await res.json();
  } catch (_e) {
    data = {};
  }
  if (!res.ok) {
    const err = new Error(data.detail || "Something went wrong. Please try again.");
    err.status = res.status;
    err.data = data;
    throw err;
  }
  return data;
}

export const api = {
  get: (p) => request(p),
  post: (p, b) => request(p, { method: "POST", body: b }),
  patch: (p, b) => request(p, { method: "PATCH", body: b }),
  del: (p) => request(p, { method: "DELETE" }),
};
